var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"54px"}},[_c('v-select',{attrs:{"items":_vm.$i18n.availableLocales,"hide-details":"auto"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.uppercase(item)))]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.uppercase(item)))]}}]),model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }